import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'
import { tzNormalizeDate } from '../../../../utils/date'
import { TIME_FORMAT } from '../../../../config/locale'
import './RoadBookingItineraryCard.css'

const RoadBookingItineraryCard = ({ itinerary, onClick, itineraryIdSelected }) => {

  const isSelected = itineraryIdSelected === itinerary.id;

  return (
    <Card key={itinerary.id} className={`mt-4 p-3 ${isSelected ? 'bg-primary' : ''}`} type='button'
      onClick={() => onClick(itinerary)}>
      <p className='road-booking route'>
        <span>{itinerary.origin.name}</span>
        <i className='fa fa-arrow-right mx-3' />
        <span>{itinerary.destination.name}</span>
      </p>
      <h2 className='road-booking title'>{itinerary.companyBusId || '-'}</h2>
      <div className='flex row justify-content-between align-items-center mx-3'>
        <div>
          <p className=''>
            <i className="fa fa-2x icon-seat-economy" />
            <span className='road-booking text'>
              {itinerary.availableSeats}
            </span>
          </p>
        </div>
        <div>
          <p className='road-booking text'>
            <i className='fa fa-clock-o mx-2 fa-1x' />
            <span>{tzNormalizeDate({ date: itinerary.departureTime, format: TIME_FORMAT })}</span>
          </p>
        </div>
      </div>
    </Card>
  )
}
RoadBookingItineraryCard.propTypes = {
  itinerary: PropTypes.shape({
    id: PropTypes.number.isRequired,
    origin: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    destination: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    companyBusId: PropTypes.string.isRequired,
    availableSeats: PropTypes.number.isRequired,
    departureTime: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  itineraryIdSelected: PropTypes.number,
}

RoadBookingItineraryCard.defaultProps = {
  itineraryIdSelected: null,
}

export default RoadBookingItineraryCard
